import Backbone from 'backbone';

export default Backbone.View.extend({
    initialize: function () {
    }
});


// WEBPACK FOOTER //
// ./views/layout/BreadcrumbElementController.js